export default "__VITE_ASSET__DsaApHx2__"